import * as React from 'react';
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import type { Pagination } from 'contracts/Pagination';
import type {
  Filters,
  PaginationControl,
} from 'hooks/store/restricted-products/use-restriction-event-search-params';
import { api, handleApiError, applyQueryString } from 'services/api';

type ApiResponse = {
  data: RestrictionEvent[]
  meta: Pagination
}

type Payload = {
  filters?: Filters
  paginationControl?: PaginationControl
}

export const useFetchRestrictionEvents = () => {
  const fetchRestrictionEvents = React.useCallback(async (payload: Payload) => {
    try {
      const url = applyQueryString('/restricted-materials/events', {
        ...payload?.filters,
        ...payload?.paginationControl,
      });
      const { data } = await api.get<ApiResponse>(url);
      return { data: data.data, pagination: data.meta };
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { fetchRestrictionEvents };
};
